import { VStack, RadioGroup, Radio, Text } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import { useStores } from "../store/store_context";

const SelectStatusDeal = observer(() => {
  const { pageStore } = useStores();

  const handleChange = (value) => {
    pageStore.updateStatusDeal(value || "all");
    pageStore.updateSelectedOneDepartment("");
  };

  return (
    <VStack align="start">
      <Text color="#EEEEEE">Статус сделки:</Text>
      <RadioGroup
        onChange={handleChange}
        value={pageStore.status_deal || "all"}
      >
        <VStack align="start" spacing={2}>
          
          <Radio value="opened" colorScheme="blue" color="#EEEEEE">
            <Text color="#EEEEEE">Открытая</Text>
          </Radio>
          <Radio value="closed" colorScheme="blue" color="#EEEEEE">
            <Text color="#EEEEEE">Закрытая</Text>
          </Radio>
          <Radio value="all" colorScheme="blue" color="#EEEEEE">
            <Text color="#EEEEEE">Выбрать все</Text>
          </Radio>
        </VStack>
      </RadioGroup>
    </VStack>
  );
});

export default SelectStatusDeal;
